import iro from '@jaames/iro'

export default class ColorPicker {
    #element
    #outputElement
    #colorPicker

    constructor(element) {
        this.#element = element
        this.#outputElement = document.querySelector(element.dataset.gpTarget)

        this.#bindEvents()
    }

    static initAll(selector) {
        Array.from(document.querySelectorAll(selector), (element) => new ColorPicker(element))
    }

    getRgbaColor() {
        return this.#outputElement.value
    }

    setRgbaColor(rgba) {
        this.#outputElement.value = rgba
    }

    // Check if valid rgb or rgba color
    isValidRgbaColor(color) {
        const range = '(\\d|[1-9]\\d|1\\d{2}|2[0-4]\\d|2[0-5]{2})'
        const alpha = '([01]|0?\\.\\d+)'
        const REGEX = RegExp(
            '^(?:rgb\\(\\s*' +
                range +
                '\\s*,\\s*' +
                range +
                '\\s*,\\s*' +
                range +
                '\\s*\\)|rgba\\(\\s*' +
                range +
                '\\s*,\\s*' +
                range +
                '\\s*,\\s*' +
                range +
                '\\s*,\\s*' +
                alpha +
                '\\s*\\))$'
        )

        return !!REGEX.exec(color)
    }

    refreshColorPicker() {
        let inputColor = this.getRgbaColor()

        if (inputColor.length < 6 || (inputColor.startsWith('#') && inputColor.length < 7)) {
            return
        }

        if (!inputColor.startsWith('rgb') && !inputColor.startsWith('#')) {
            inputColor = '#' + inputColor
        } else if (inputColor.startsWith('rgb') && !this.isValidRgbaColor(inputColor)) {
            return
        }

        this.#colorPicker.color.set(inputColor)
        this.setRgbaColor(this.#colorPicker.color.rgbaString)
    }

    #bindEvents() {
        // Initialize the color picker
        this.#colorPicker = new iro.ColorPicker(this.#element, {
            color: this.getRgbaColor(),
            width: parseInt(this.#element.dataset.gpWidth) || null,
            layout: [
                {
                    component: iro.ui.Box,
                },
                {
                    component: iro.ui.Slider,
                    options: {
                        sliderType: 'hue',
                    },
                },
                {
                    component: iro.ui.Slider,
                    options: {
                        sliderType: 'alpha',
                    },
                },
            ],
        })

        // Handle a color change when the color changed through the picker
        this.#colorPicker.on('color:change', (color) => {
            this.setRgbaColor(color.rgbaString)
        })

        // Handle a color change when the hex is changed
        this.#outputElement.addEventListener('keyup', () => {
            this.refreshColorPicker()
        })

        // Handle a color change when the hex is changed and input is blurred
        this.#outputElement.addEventListener('blur', () => {
            this.refreshColorPicker()
        })
    }
}
